import NavBar, { TabKey } from "src/components/atoms/NavBar/NavBar";
import * as S from "./PageContainer.style";
import { useViewport } from "src/common/hooks/ViewPort";

interface PageContainerProps {
  isNavBar: boolean;
  children: React.ReactElement;
  active: TabKey | null;
  $bgColor?: string;
}
export const PageContainer = ({
  isNavBar,
  children,
  active,
  $bgColor,
}: PageContainerProps) => {
  const { px } = useViewport();
  return (
    <S.PageContainer $bgColor={$bgColor}>
      {children}
      {isNavBar && <NavBar active={active} px={px} />}
    </S.PageContainer>
  );
};
